export const jobRequests = {
  PageNumber: 1,
  SearchText: "",
  SortOrder: 1,
  PageSize: 5,
  OrderBy: "",
  ParameterOne: "",
  ParameterTwo: "",
  ParameterThree: "",
  url: process.env.REACT_APP_API_TODO_LIST_ENDPOINT,
  accessToken: localStorage.getItem("AccessToken") || "llll",
};
